/* Finsbury China: phone navigation behaviour. Loaded by sections/fc-mobile-nav.liquid. */
(function () {
  var bar = document.getElementById('fcmn');
  if (!bar) return;
  var header = document.querySelector('header-component');

  // ---- Search, Basket and Menu tabs press the theme's own (hidden) header buttons ----
  function menuSummary() { return header && header.querySelector('summary.header__icon--menu'); }
  function searchButton() { return header && header.querySelector('search-button button'); }
  function cartButton() {
    var bubble = header && header.querySelector('.cart-bubble');
    return bubble && bubble.closest('button, a');
  }

  bar.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-fcmn]');
    if (!tab) return;
    var kind = tab.getAttribute('data-fcmn');
    var target = kind === 'menu' ? menuSummary() : kind === 'search' ? searchButton() : cartButton();
    if (!target) return; // theme control not found: the tab works as a normal link instead
    e.preventDefault();
    e.stopPropagation(); // stop the theme treating this as an "outside click" and closing the menu again
    target.click();
  });

  // ---- Highlight the Menu tab while the menu is open ----
  var menuTab = bar.querySelector('[data-fcmn="menu"]');
  var summary = menuSummary();
  var details = summary && summary.closest('details');
  if (details) {
    var syncMenu = function () { menuTab.setAttribute('aria-expanded', details.open ? 'true' : 'false'); };
    new MutationObserver(syncMenu).observe(details, { attributes: true, attributeFilter: ['open'] });
    syncMenu();
  }

  // ---- Mirror the header's basket count (the theme keeps it up to date) ----
  var countEl = bar.querySelector('.fcmn-count');
  var cartTab = bar.querySelector('[data-fcmn="cart"]');
  function syncCount() {
    var src = header && header.querySelector('.cart-bubble__text-count');
    if (!src) return;
    var n = parseInt(src.textContent, 10) || 0;
    if (countEl.textContent !== String(n)) countEl.textContent = n;
    countEl.hidden = n === 0;
    cartTab.setAttribute('aria-label', n ? 'Basket, ' + n + (n === 1 ? ' item' : ' items') : 'Basket');
  }

  // ---- Phone, email and opening hours at the bottom of the menu ----
  var contact = document.getElementById('fcmn-contact');
  function placeContact() {
    if (!contact || !header) return;
    var nav = header.querySelector('.menu-drawer__navigation');
    if (nav && contact.parentNode !== nav) {
      nav.appendChild(contact);
      // Line up with the menu links, whatever spacing the theme uses
      var list = nav.querySelector('ul');
      if (list) {
        var pad = getComputedStyle(list).paddingLeft;
        contact.style.marginLeft = pad;
        contact.style.marginRight = pad;
      }
      contact.hidden = false;
    }
  }

  // The theme can re-draw parts of the header (e.g. after adding to the basket),
  // so keep the count and the contact details in place whenever it changes.
  if (header) {
    new MutationObserver(function () { syncCount(); placeContact(); })
      .observe(header, { subtree: true, childList: true, characterData: true });
  }
  syncCount();
  placeContact();

  // ---- Quote forms: email and phone keyboards ----
  // The quote form app uses plain text boxes for email and phone, so phones showed the
  // normal keyboard (and capitalised the first letter of email addresses). This runs as the
  // field is touched, before the keyboard opens, because the form loads after the page.
  function tuneField(el) {
    if (!el || el.tagName !== 'INPUT' || el.dataset.fcTuned) return;
    var name = (el.name || '').toLowerCase();
    if (name === 'email' || name.indexOf('email-') === 0) {
      if (el.type === 'text') el.setAttribute('inputmode', 'email');
      el.setAttribute('autocapitalize', 'off');
      el.setAttribute('autocorrect', 'off');
      el.setAttribute('spellcheck', 'false');
      if (!el.getAttribute('autocomplete')) el.setAttribute('autocomplete', 'email');
    } else if (name.indexOf('phone') === 0) {
      if (el.type === 'text') el.setAttribute('inputmode', 'tel');
      if (!el.getAttribute('autocomplete')) el.setAttribute('autocomplete', 'tel');
    }
    el.dataset.fcTuned = '1';
  }
  function onTouch(e) { tuneField(e.target); }
  document.addEventListener('touchstart', onTouch, { passive: true, capture: true });
  document.addEventListener('focusin', onTouch, true);

  // ---- Sticky add to cart on product pages ----
  var atc = document.getElementById('fcatc');
  var main = document.getElementById('MainContent');
  if (!atc || !main) return;

  function realButton() { return main.querySelector('add-to-cart-component button[name="add"]'); }
  if (!realButton()) { atc.remove(); return; }
  document.body.classList.add('fcatc-on');

  var btn = atc.querySelector('.fcatc-btn');
  var priceEl = atc.querySelector('.fcatc-price');
  var variantEl = atc.querySelector('.fcatc-variant');
  var isOpen = false;

  function clean(t) { return (t || '').replace(/\s+/g, ' ').trim(); }

  function sync() {
    var real = realButton();
    if (!real) return;
    btn.disabled = real.disabled;
    btn.textContent = clean(real.textContent) || 'Add to cart';
    var price = main.querySelector('product-price .price');
    priceEl.textContent = price ? clean(price.textContent) : '';
    var picker = main.querySelector('variant-picker');
    var picked = [];
    if (picker) {
      [].forEach.call(picker.querySelectorAll('input:checked'), function (i) { picked.push(i.value); });
      [].forEach.call(picker.querySelectorAll('select'), function (sel) { picked.push(sel.value); });
    }
    variantEl.textContent = picked.join(' / ');
  }

  function setOpen(open) {
    if (open === isOpen) return;
    isOpen = open;
    if (open) sync();
    atc.classList.toggle('is-open', open);
    atc.setAttribute('aria-hidden', open ? 'false' : 'true');
    btn.tabIndex = open ? 0 : -1;
  }

  // Show once the main buy buttons have scrolled up off the top of the screen
  function buyArea() {
    var real = realButton();
    return real && (real.closest('product-form-component') || real.closest('form') || real);
  }
  function check() {
    var area = buyArea();
    setOpen(!!area && area.getBoundingClientRect().bottom < 0);
  }
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check, { passive: true });
  check();

  // Keep price / variant / sold-out state in step with the page
  var pending = false;
  new MutationObserver(function () {
    if (pending || !isOpen) return;
    pending = true;
    setTimeout(function () { pending = false; sync(); }, 100);
  }).observe(main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
  main.addEventListener('change', function () { setTimeout(sync, 150); });

  btn.addEventListener('click', function () {
    var real = realButton();
    if (real && !real.disabled) real.click();
  });
})();